import type { Method } from 'lib/axios';

import { APICallV4 } from '../APICall';

interface RequestData {
    task_id: string;
}

interface RespData {
    status?: 'pending' | 'processing' | 'completed';
}

export class ImproveImageApiPollCall extends APICallV4<RespData, RequestData> {
    _method = 'improve/image/status';
    _type: Method = 'get';
}

export const improveImagePollApiCall = (args: RequestData) => new ImproveImageApiPollCall().makeRequest(args);
